import { render } from "./AppLoader.vue?vue&type=template&id=649983d2&scoped=true&ts=true"
import script from "./AppLoader.vue?vue&type=script&lang=ts"
export * from "./AppLoader.vue?vue&type=script&lang=ts"

import "./AppLoader.vue?vue&type=style&index=0&id=649983d2&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649983d2"]])

export default __exports__